import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'wonderbly-components/lib/Panel';
import RichText from '../Prismic/RichText';
import './IntroPartial.scss';

const IntroPartial = props => (
  <section className="intro-partial">
    <div className="container-guttered">
      <Panel border="shadow">
        <p className="text-kilo">{props.title}</p>
        <hr />
        <RichText fields={[{
          type: 'paragraph',
          text: props.description,
        }]}
        />
      </Panel>
    </div>
  </section>
);

IntroPartial.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default IntroPartial;



// WEBPACK FOOTER //
// ./src/client/js/view/components/IntroPartial/IntroPartial.js